interface TagProps {
  label: string;
  tone?: "primary" | "accent" | "secondary" | "neutral";
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
  neutral: "bg-background-200 text-foreground-700",
};

export default function Tag({ label, tone = "neutral" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 font-label text-xs leading-none ${toneMap[tone]}`}
    >
      {label}
    </span>
  );
}